import { render, staticRenderFns } from "./ClientWallet.vue?vue&type=template&id=2ce5f710&scoped=true&"
import script from "./ClientWallet.vue?vue&type=script&lang=js&"
export * from "./ClientWallet.vue?vue&type=script&lang=js&"
import style0 from "./ClientWallet.vue?vue&type=style&index=0&id=2ce5f710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5f710",
  null
  
)

export default component.exports